import { PlusOutlined, UpOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Button,
  type FormProps,
  Flex,
  theme,
  Dropdown,
  MenuProps,
  Select,
  message,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { API_BASE_URL, API_URL_CONTACT_GROUPS } from "@/services/XCONS_ENV";
import { axiosInstance } from "@/utilities";
import { useContext, useEffect, useState } from "react";
import { SmartMenuContext } from "@/config/context/smartMenuContext";
import { useSelectedStores } from "@/config/context/SelectedItemsContext";

const sellersMock = [
  {
    sellerCode: "puntoseco",
    label: "Puntoseco",
  },
];

type Seller = {
  sellerCode: string;
  label: string;
};

type GroupsEditProps = {
  formProps?: FormProps;
  t: (key: string) => string;
  storesSelectProps?: any;
  setIsGroupDrawerOpen?: any;
  refetch?: any;
  selectedGroup?: any;
};

export const GroupsEdit: React.FC<GroupsEditProps> = ({
  formProps,
  t,
  storesSelectProps,
  setIsGroupDrawerOpen,
  refetch,
  selectedGroup,
}) => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const { selectedStores } = useSelectedStores();
  const [storeCode, setStoreCode] = useState<string>(selectedStores[0]?.code);

  const handleDeleteGroup = async () => {
    if (!selectedGroup?.contactGroupId) return;
    setDeleting(true);
    try {
      await axiosInstance.delete(
        `${API_BASE_URL}/contact-groups/${selectedGroup.contactGroupId}`,
      );
      message.success("Grupo eliminado correctamente");
      refetch?.();
      setIsGroupDrawerOpen?.(false);
    } catch (error: any) {
      console.error(error);
      message.error("Error al eliminar el grupo");
    } finally {
      setDeleting(false);
    }
  };

  const handleEditGroup = async () => {
    if (!selectedGroup?.contactGroupId) return;

    try {
      const { groupName } = await form.validateFields();
      const trimmed = String(groupName ?? "").trim();

      if (!trimmed) {
        message.warning("El nombre no puede estar vacío");
        return;
      }
      if (trimmed === (selectedGroup.name ?? "")) {
        message.info("No hay cambios para guardar");
        return;
      }

      setSaving(true);

      await axiosInstance.put(
        `${API_BASE_URL}/contact-groups/${selectedGroup.contactGroupId}`,
        { name: trimmed },
      );

      message.success("Grupo actualizado correctamente");
      refetch?.();
      setIsGroupDrawerOpen?.(false);
    } catch (error: any) {
      if (error?.errorFields) {
        return;
      }
      console.error(error);
      message.error("No se pudo actualizar el grupo");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      groupName: selectedGroup?.name ?? "",
      // storeCode: selectedGroup?.storeCode
    });
  }, [selectedGroup, form]);

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={{
        groupName: selectedGroup?.name ?? "",
      }}
    >
      <Form.Item
        label={
          <span style={{ color: token.colorTextTertiary }}>
            Name of the group
          </span>
        }
        name="groupName"
      >
        <Flex vertical>
          <Input defaultValue={selectedGroup?.name} type="text" />
        </Flex>
      </Form.Item>

      <p>
        If you edit the group, it will be edited for all contacts to whom the
        group was assigned.
      </p>

      {/* <Form.Item
        label={
          <span style={{ color: token.colorTextTertiary }}>
            Link to a store
          </span>
        }
        name="storeCode"
        initialValue={selectedGroup?.storeCode}
      >
        <Flex vertical>
          <Select
            allowClear
            options={storesSelectProps?.map((option: any) => ({
              label: option?.name as string,
              value: option?.code as string,
            }))}
          />
        </Flex>
      </Form.Item> */}

      <Flex
        align="center"
        justify="space-between"
        gap="8px"
        style={{
          position: "absolute",
          bottom: 48,
          right: 24,
          width: 360,
        }}
      >
        <Button
          type="default"
          danger
          onClick={() => handleDeleteGroup()}
          loading={deleting}
          disabled={saving}
        >
          {t("buttons.delete")}
        </Button>

        <Flex gap={8}>
          <Button
            type="default"
            onClick={() => setIsGroupDrawerOpen(false)}
            disabled={saving || deleting}
          >
            {t("buttons.cancel")}
          </Button>
          <Button
            loading={saving}
            disabled={deleting}
            style={{ width: "auto" }}
            onClick={() => handleEditGroup()}
            type="primary"
          >
            {t("button.save")}
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
};
